module.exports = __webpack_public_path__ + "img/path-copy.f90fa684.svg";